import { render, staticRenderFns } from "./TeacherStaticsTable.vue?vue&type=template&id=033a8985&scoped=true&"
import script from "./TeacherStaticsTable.vue?vue&type=script&lang=js&"
export * from "./TeacherStaticsTable.vue?vue&type=script&lang=js&"
import style0 from "./TeacherStaticsTable.vue?vue&type=style&index=0&id=033a8985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a8985",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VDataTable,VRow})
